define(
    'viewmodels/secured/explorer/details/tabs/actions/EmailAsLinkAction',[
        "viewmodels/secured/explorer/context",
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "services/service.dialog",
        "services/service.documents",
        "services/config",
        "i19n!i19n/strings"
    ],
    function (ctx, Action, dialogService, documentsService, config, i19n) {

        var EmailAsLinkAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.emailaslink,
                    message: i19n.to.emailaslink
                },
                dialogoptions: {
                    ok: {
                        label: i19n.to.okay,
                        message: i19n.to.emailaslink
                    },
                    cancel: {
                        label: i19n.to.cancel,
                        message: i19n.to.cancel
                    }
                }
            };

            __extends(_Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-link", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                var documents = action.context.checkedDocuments();
                var ids = "";
                _.map(documents, function (itm) {
                    ids = ids + "_" + itm.docIdVersionId;
                });
                if (ids != "") {
                    ids = ids.substr(1, ids.length -1);
                }
                console.warn(ids);
                require(['services/service.runapp'], function (fp) {
                    var url = "fpemaillink://" + ids + "/";

                    fp.run($("#protocol-container"), url);
                    
                    complete();
                });
            }

            return _Action;

        })(Action);

        return EmailAsLinkAction;

    });
